import '../css/app.css'
import jQuery from 'jquery'
import Nav from './components/nav'
import Slider from './components/slider'
import videoPlayer from './components/video'
import Accordion from './components/accordion'
import fetchNews from './utilities/fetchNews'
import loadJuicer from './utilities/loadJuicer'

window.$ = window.jQuery = jQuery

window.addEventListener('DOMContentLoaded', () => {
  const hasNav = document.getElementById('nav')
  const hasVideoPlayer = document.getElementById('js-hero-video')
  const hasAccordion = document.querySelectorAll('.thumbnails')
  const hasSlider = document.getElementById('my-keen-slider')
  const hasNews = document.getElementById('news-archive')
  const hasJuicer = document.getElementById('juicer-feed')

  if (hasNav) Nav()
  if (hasAccordion) Accordion()
  if (hasVideoPlayer) videoPlayer()
  if (hasSlider) Slider()
  if (hasNews) fetchNews()
  if (hasJuicer) loadJuicer()
})
